import { omMessage } from '@owma/kit'

import parse from 'html-react-parser'

import i18n from 'i18n'
import localforage from 'myStore'
import { createJAM, destroyJAM, getJamClient } from 'libs/jamUtil'

import { setEnvParam } from 'env'

import { ClientJS } from 'clientjslite'

import dataManager from 'pages/main/data/DataManager'
import { warningBase, checkOpenedWindow } from 'utils/ui'

import { store as reduxStore } from 'index'

// import conf from 'conf'

const client = new ClientJS()

interface ProviderInfo {
  type: string
  auth: string
  appconfig: Record<string, any>
}

interface UserInfo {
  id: string
  name: string
  email: string
  uid: string
  avatar: string | null
  role: string
  lastLogin: string
  workspace: Record<string, any>
}

function openLandingPopup(smallSize?: boolean): boolean {
  const windowSize = {
    width: Math.min(window.screen.availWidth, 1024),
    height: Math.min(window.screen.availHeight, 711),
  }
  const windowLocation = {
    left: (window.screen as any).availLeft + window.screen.availWidth / 2 - windowSize.width / 2,
    top: (window.screen as any).availTop + window.screen.availHeight / 2 - windowSize.height / 2,
  }

  const options =
    smallSize !== true
      ? `width=${windowSize.width},height=${windowSize.height},left=${windowLocation.left},top=${windowLocation.top}`
      : `width=${10},height=${10},left=${windowLocation.left},top=${windowLocation.top}`

  const winName = `landingWin`

  ;(window as any).loginChatWin = window.open('', winName, options)
  checkOpenedWindow((window as any).loginChatWin)

  if ((window as any).loginChatWin == null) {
    warningBase({
      title: i18n.t('common.title.blockPopup'),
      content: i18n.t('common.warning.blockPopup'),
    })

    reduxStore.dispatch({
      type: 'user/LOGOUT',
    })

    return false
  }

  return true
}

function autoDiscover(email: string, saveEnv: boolean): Promise<ProviderInfo> {
  // let promise = null;
  // if (process.env.REACT_APP_TARGET === 'production') {
  const promise = new Promise<ProviderInfo>((resolve) => {
    const info: ProviderInfo = {
      type: 'imap',
      auth: 'basic',
      appconfig: {},
    }

    if (saveEnv === true) {
      setEnvParam('providerInfo', info)
    }
    resolve(info)
  })
  // } else {
  //   promise = new Promise((resolve, reject) => {
  //     restLandingClient
  //       .get('/autodiscover/json', {
  //         email,
  //         env: process.env.REACT_APP_TARGET === 'production' ? 'prod' : 'dev',
  //         app: 'work',
  //       })
  //       .then((res) => {
  //         if (res.data.code === 200) {
  //           const { url } = res.data.data
  //           const apiUrl = url.endsWith('/') === true ? `${url}v1` : `${url}/v1`
  //           const appConfigClient = new RestClient(apiUrl, fetch, false)
  //           appConfigClient
  //             .post('/provisioning/appconfig', { email })
  //             .then((res2) => {
  //               if (res2.data.code === 200) {
  //                 const { appconfig } = res2.data.data
  //                 const [appconfig0] = appconfig
  //                 const info = {
  //                   type: appconfig0.AppEmailServiceProvider.toLowerCase(),
  //                   auth: appconfig0.AppAuthenticationMethod.toLowerCase(),
  //                   appconfig,
  //                 }
  //
  //                 if (saveEnv === true) {
  //                   setEnvParam('providerInfo', info)
  //                 }
  //                 resolve(info)
  //               } else {
  //                 setEnvParam('providerInfo', null)
  //                 reject(new Error('error'))
  //               }
  //             })
  //             .catch((err) => {
  //               setEnvParam('providerInfo', null)
  //               reject(err)
  //             })
  //         } else {
  //           setEnvParam('providerInfo', null)
  //           reject(new Error('error'))
  //         }
  //       })
  //       .catch((err) => {
  //         setEnvParam('providerInfo', null)
  //         reject(err)
  //       })
  //   })
  // }

  return promise
}

export function checkEmail(
  email: string,
  onSetInfoType?: ((infoType: string) => void) | null,
  onEnd?: (() => void) | null,
): void {
  const isSafari = client.isSafari()

  if (isSafari !== true || openLandingPopup(true) === true) {
    autoDiscover(email, true)
      .then((res) => {
        console.log('autoDiscover - res', res)

        if (res.type != null) {
          const info = res
          let notFound = true
          if (info != null) {
            const infoType = info.type

            if (infoType === 'ms365' || infoType === 'google') {
              notFound = false
              if (isSafari === true || openLandingPopup(false) === true) {
                reduxStore.dispatch({
                  type: 'user/LOGIN',
                  payload: {
                    email,
                  },
                })
              }
            } else if (infoType === 'imap' && info.auth === 'basic') {
              notFound = false

              if ((window as any).loginChatWin != null) {
                ;(window as any).loginChatWin.close()
              }
            }

            if (onSetInfoType != null) {
              onSetInfoType(infoType)
            }
          }

          if (notFound === true) {
            if ((window as any).loginChatWin != null) {
              ;(window as any).loginChatWin.close()
            }

            const htmlStr = i18n.t('login.autoDiscover.notFoundDesc', {
              email: '<a href="mailto:sales@rework.so">sales@rework.so</a>',
            })
            const elem = parse(htmlStr)

            warningBase({
              title: i18n.t('login.autoDiscover.notFoundTitle'),
              content: elem,
            })
          }
        }

        if (onEnd != null) {
          onEnd()
        }
      })
      .catch((err) => {
        console.log(' autoDiscover err - ', err)
        if ((window as any).loginChatWin != null) {
          ;(window as any).loginChatWin.close()
        }

        if (onEnd != null) {
          onEnd()
        }
      })
  }
}

export async function login(email: string, password: string): Promise<string> {
  console.log('login --- ', email)
  const accessToken = btoa(email + ':' + password)

  try {
    await createJAM(accessToken, 'Basic')

    await localforage.setItem('app.user.jmap.tokenType', 'Basic')
    await localforage.setItem('app.user.jmap.token', accessToken)

    return 'success'
  } catch (e) {
    omMessage.info('login failed.')
    console.log('login failed.')
    throw e
  }
}

export async function register(/* email: string, password: string, name: string */): Promise<boolean> {
  function fakeRegister(): Promise<boolean> {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(true)
      }, 200)
    })
  }

  return fakeRegister()
}

async function getUserInfo(/* jam: any */): Promise<UserInfo> {
  const myAccount = await getJamClient().getPrimaryAccount()

  const ret: UserInfo = {
    id: myAccount,
    name: myAccount,
    email: myAccount,
    // timeFormat: user.mailboxSettings?.timeFormat || '',
    // timeZone: user.mailboxSettings?.timeZone || 'UTC'
    uid: '',
    avatar: null,
    role: '',
    lastLogin: '',
    workspace: {},
  }

  // dataManager.firstLoad()

  return ret
}

export async function currentAccount(): Promise<UserInfo | false> {
  const tokenType = await localforage.getItem<string>('app.user.jmap.tokenType')
  const token = await localforage.getItem<string>('app.user.jmap.token')

  if (token != null) {
    const jam = await createJAM(token, tokenType || 'Basic')

    if ((jam as any).error === true) {
      // refreshToken 중 인증에러가 발생한 경우에만 로그아웃처리함.
      return false
    }

    const ret = await getUserInfo()

    // const session = await jam._client.session;
    // if (session != null && session.capabilities != null) {
    //   const wsInfo = session.capabilities['urn:ietf:params:jmap:websocket'];
    //   if (wsInfo != null && wsInfo.url != null) {
    //     startWS();
    //   }
    // }

    return ret
  } else {
    return false
  }
}

export async function logout(): Promise<boolean> {
  // return firebaseAuth()
  //   .signOut()
  //   .then(() => true)

  async function fakeLogout(): Promise<boolean> {
    destroyJAM()

    dataManager.clearAll()

    await localforage.removeItem('app.user.token')

    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(true)
      }, 200)
    })
  }

  return await fakeLogout()
}

const jwt = {
  login,
  currentAccount,
  logout,
}

export default jwt
